import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { GithubLogin } from './GithubLogin';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';

export const GithubLoginExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'GithubLogin',
    component: GithubLogin,
  }),
);
